import api from "../api";

export const useSubscribeUser = (data) =>
  api.post(`user/subscribe/${data}`).then((res) => res.data);
